import React from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Divider,
} from '@mui/material';
import { CheckCircle, Receipt, Home } from '@mui/icons-material';

const PaymentSuccess: React.FC = () => {
  const transactionId = 'TXN_' + Date.now();
  const paymentDate = new Date().toLocaleDateString();
  const amount = '$165.00'; // Mock amount including tax

  const handleDownloadReceipt = () => {
    // In a real app, this would generate and download a PDF receipt
    alert('Receipt download would be implemented here');
  };

  const handleReturnHome = () => {
    window.location.href = '/';
  };

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Avatar
        sx={{
          bgcolor: 'white',
          width: 80,
          height: 80,
          mx: 'auto',
          mb: 3,
        }}
      >
        <CheckCircle sx={{ fontSize: 50 }} />
      </Avatar>

      <Typography variant="h4" color="white" gutterBottom>
        Paiement réussi!
      </Typography>

      <Typography variant="body1" color="white" sx={{ mb: 4 }}>
        Votre paiement a été traité avec succès. Vous recevrez un email de confirmation sous peu.
      </Typography>

      <Card variant="outlined" sx={{ maxWidth: 400, mx: 'auto', mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Détails de la transaction
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              ID de la transaction:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {transactionId}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Amount:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {amount}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Date:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {paymentDate}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              Status:
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="success.main">
              Completed
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          startIcon={<Receipt />}
          onClick={handleDownloadReceipt}
          style={{ color: 'white' , borderColor: 'white'}}
        >
          Télécharger le reçu
        </Button>
        
        <Button
          variant="contained"
          startIcon={<Home />}
          onClick={handleReturnHome}
        >
          Retour à la page d'accueil
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
        Si vous avez des questions concernant cette transaction, veuillez contacter notre équipe de support.
      </Typography>
    </Box>
  );
};

export default PaymentSuccess; 